<template>
  <div class="login">
    <div class="login-bg">
      <!-- <a href="http://www.zhongpukeji.cn/#/home" class="logo_img">
        <img src="../../assets/img/layout/logo.png"
              alt="">
      </a> -->
      <div class="login-content">
        <!-- <h3>产业链供应链综合服务平台—客商门户</h3> -->
        <div style="margin-top: -60px;padding-bottom: 20px">
          <img src="../../assets/img/layout/logo.png"
              alt="">
        </div>
        <div class="form-content">
          <div class="bg-img">
            <img src="../../assets/img/layout/login_img.png"
                 style="height: 100%;" />
          </div>
          <div class="form-box clearfix">
            <div>
              <h1>欢迎注册</h1>
              <el-form :model="dataForm"
                       :rules="dataRule"
                       ref="dataForm"
                       @keyup.enter.native="dataFormSubmit()"
                       status-icon>
                <el-form-item prop="mobile" style="background:#fff">
                  <el-input v-model="dataForm.mobile"
                            class="account"
                            placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item prop="password" style="background:#fff">
                  <el-input v-model="dataForm.password"
                            type="password"
                            class="password"
                            placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item prop="captcha" style="background:#fff">
                  <div class="captchaBox">
                    <el-input v-model="dataForm.captcha"
                              class="code"
                              placeholder="短信验证码">
                    </el-input>
                    <el-button size="mini"
                               @click="getCode"
                               :loading="laodCode"
                               :disabled="codeDisabled"
                               class="slotButton">
                      {{
                        codeDisabled ? "重新发送" + count + "S" : "发送验证码"
                      }}
                    </el-button>
                  </div>
                </el-form-item>
              </el-form>
              <el-button class="login-btn-submit"
                         type="primary"
                         @click="dataFormSubmit()"
                         style="width:300px;height:45px;background:#00b541;border-radius:6px;border:0;margin-top:18px;font-size:16px;"
                         size="medium">立即注册</el-button>
              <div style="margin-top:15px">
                <span class="register"
                      @click="$router.push({ name: 'login' })">已有账户？立即登录</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    let pwPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,20}$/
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (!pwPattern.test(value)) {
        callback(new Error('密码必须是包含大小写字母和数字的8到20位字符'))
      } else {
        callback()
      }
    }
    let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    let gangPhone = /^[0-9]{8}$/
    let validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value) && !gangPhone.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      laodCode: false,
      time: null,
      count: null,
      account: true,
      isForm: true,
      setTenantState: false,
      codeDisabled: false,
      dialog: false,
      tenant: '',
      tenantId: '',
      tenants: [],
      dataForm: {
        mobile: '',
        password: '',
        captcha: ''
      },
      form: {},
      dataRule: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' }
        ]
      },
      captchaPath: '',
      checked: false,
      fullscreenLoading: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 获取验证码
    getCode () {
      let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      let gangPhone = /^[0-9]{8}$/
      if (!this.dataForm.mobile) {
        this.$message.error('请先输入手机号')
      } else if (
        !phoneReg.test(this.dataForm.mobile) &&
        !gangPhone.test(this.dataForm.mobile)
      ) {
        this.$message.error('请输入正确的手机号')
      } else {
        this.laodCode = true
        this.$http({
          url: this.$http.adornUrl(
            window.SITE_CONFIG.contextPath +
            '/p/message/mobile/sendRegMobileCode?mobile=' +
            this.dataForm.mobile
          ),
          method: 'get'
        })
          .then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.$message.success('发送成功')
              this.codeDisabled = true
              const TIME_COUNT = 60
              this.count = TIME_COUNT
              this.time = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--
                } else {
                  this.codeDisabled = false
                  clearInterval(this.time)
                }
              }, 1000)
            } else {
              this.$message.error(data.message)
            }
          })
          .finally(() => {
            this.laodCode = false
          })
      }
    },
    dataFormSubmit () {
      console.log(this.dataForm)
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.fullscreenLoading = true
          this.$http({
            url: this.$http.adornUrl(
              window.SITE_CONFIG.contextPath + '/p/user/reg'
            ),
            method: 'post',
            data: {
              tenantId: 3133981754195968,
              loginName: this.dataForm.mobile,
              mobile: this.dataForm.mobile,
              realName: this.dataForm.mobile, // 姓名默认为手机号
              password: this.dataForm.password,
              captcha: this.dataForm.captcha
            }
          })
            .then(({ data }) => {
              if (data && data.code === 'C0000') {
                this.$message.success(data.message)
                this.$router.push({
                  name: 'login'
                })
              } else {
                this.$message.error(data.message)
              }
              this.fullscreenLoading = false
            })
            .catch(() => {
              this.fullscreenLoading = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.trial-btn {
  display: inline-block;
  width: 120px;
  height: 32px;
  // background: #fff;
  border: 1px solid #fff;
  line-height: 30px;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}
.captchaBox {
  display: flex;
  justify-content: space-between;
  .slotButton {
    width: 135px;
    margin: 0 0 0 1px;
    background: #fff;
    border: 1px solid #fff;
    color: #00b541;
    font-size: 12px;
    display: flex;
    line-height: 28px;
    justify-content: center;
    border-bottom: 1px solid #eee;
    border-radius: 0;
  }
  .slotButton:hover {
    background: #00b541 !important;
    color: #fff;
  }
}
.clearfix:before,
.clearfix:after {
  content: "";
  display: block;
  clear: both;
  height: 0;
  line-height: 0;
}
.clearfix {
  zoom: 1;
}
html,
body {
  height: 100%;
  width: 100%;
  min-width: 1200px;
  min-height: 700px;
}
.login {
  display: table;
  width: 100%;
  height: 100%;
  _position: relative;
  .login-bg {
    vertical-align: middle;
    display: flex;
    text-align: center;
    /*background: url("../../assets/img/login/login_bg.jpg") center;
    background-size: cover;
    background-repeat: no-repeat;*/
    background: #77bcd1;
    overflow: auto;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: relative;
  }
  .login-content {
    width: 1152px;
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #00b541;
      border-color: #00b541;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #00b541;
    }
    h3 {
      font-size: 50px;
      color: #fff;
      font-family: 'alimamashuheiti';
      text-align: center;
      margin: -108px auto 50px;
    }
    .form-content {
      position: relative;
      width: 100%;
      height: 400px;
      border-radius: 9px;
      overflow: hidden;
      background: #c2e2ec;
      // background: linear-gradient(
      //   90deg,
      //   rgba(20, 142, 235, 1) 0%,
      //   rgba(255, 255, 255, 1) 60%
      // );
      img.QRCode {
        position: absolute;
        right: 3px;
        top: 3px;
        cursor: pointer;
      }
      .bg-img {
        width: 66%;
        height: 100%;
        float: left;
        // background: linear-gradient(-75deg, #0077f1, #00f6ff);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        // margin-right: 1px;
        // border-radius: 9px;
        .manager {
          position: relative;
          width: 100%;
          height: 100%;
          // border-radius: 9px;
        }
      }
      .form-box {
        width: 34%;
        height: 100%;
        float: right;
        // border-radius: 9px;
        .el-checkbox {
          color: #333;
        }
        h1 {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 50px;
          margin: 25px auto 15px;
          color: #333;
        }
        form {
          display: block;
          width: 300px;
          margin: auto;
          .account {
            background: url("../../assets/img/layout/icon_1.png");
            background-size: 26px 26px;
            background-position: 8px 8px;
            background-repeat: no-repeat;
            padding-left: 36px;
            height: 42px;
            box-sizing: border-box;
          }
          .password {
            background: url("../../assets/img/layout/icon_2.png");
            background-size: 26px 26px;
            background-position: 8px 8px;
            background-repeat: no-repeat;
            padding-left: 36px;
            height: 42px;
            box-sizing: border-box;
          }
          .code {
            background: url("../../assets/img/layout/icon_3.png");
            background-size: 26px 26px;
            background-position: 8px 8px;
            background-repeat: no-repeat;
            padding-left: 36px;
            height: 42px;
            box-sizing: border-box;
          }
        }
        form + div {
          width: 300px;
          text-align: left;
          margin: 0 auto 28px;
          i {
            float: right;
            color: #333;
            font-style: normal;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .bottomBox {
    display: flex;
    margin: 18px 48px 0 48px;
    justify-content: space-between;
  }
  .register {
    text-align: center;
    color: #333;
    cursor: pointer;
    font-size: 12px;
  }
  .register:hover {
    color: #00b541;
  }
  .QRCodeBox {
    width: 100% !important;
    height: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .is-success {
    border-bottom: 1px #67c23a solid !important;
    background: white !important;
  }
  .is-error {
    border-bottom: 1px #f56c6c solid !important;
    background: white !important;
  }
  .el-input {
    border-bottom: 1px #eeeeee solid !important;
  }
  .el-input__inner {
    border: none;
    border-radius: 0 !important;
  }
}
.radio-box {
  .el-radio {
    display: block;
    line-height: 40px;
  }
  .el-radio + .el-radio {
    margin-left: 10px;
  }
}

.logo_code {
  position: absolute;
  margin: 20px auto;
  display: flex;
  width: 1152px;
  justify-content: center;
  .code {
    width: 200px;
    height: 200px;
    background: #fff;
    padding: 20px 10px;
    img {
      width: 80%;
    }
    p {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .companyName {
    color: #fff;
    margin: 60px 10px;
    font-size: 24px;
    font-weight: bold;
    font-family: "Courier New", Courier, monospace;
    p {
      margin: 6px 0;
    }
  }
}
#wx_qrcode {
  position: relative;
  height: 100%;
  img {
    margin-top: 70px;
    padding: 14px;
    border: 1px solid #eee;
  }
  h2 {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 25px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 50px;
  }
  p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 50px;
  }
}
.login .login-content {
  position: relative;
}
.logo_img {
  position: absolute;
  width: 200px;
  left: 20px;
  top: 20px;
  img {
    width: 100%;
  }
}
.impowerBox .title,
.impowerBox .status p {
  color: #333 !important;
}
.impowerBox .loginPanel { color: #333 }
// .impowerBox .loginPanel {margin-top: 50px;color: #fff}
// .impowerBox .qrcode {width: 200px;}
// .impowerBox .info {width: 200px;}
// .status_icon {display: none}
// .js_wx_after_scan {width: 400px;}
// js_wx_after_cancel {width: 400px;}
// .js_wx_default_tip p:last-child {display:none}
// .web_qrcode_switch{color: #0ba5ff}
// .qlogin_mod{margin-top: 80px}
</style>



// WEBPACK FOOTER //
// src/views/common/register.vue